
    // AI Spped Booster  
    // Apply the 'lazyload' class to all images without the class
    document.addEventListener("DOMContentLoaded", () => {
      const images = document.querySelectorAll("img:not(.lazyload)");
      let lazyLoadedImages = JSON.parse(localStorage.getItems("lazyLoadedImages") || []);
      
      images.forEach(img => {
        img.classList.add("lazyload");
        lazyLoadedImages.push(img.src || img.dataset.src); // Store image src or data-src
      });
        
      // lazysizes - v5.3.2
      const script = document.createElement("script");
      script.src = "https://cdnjs.cloudflare.com/ajax/libs/lazysizes/5.3.2/lazysizes.min.js";
      script.integrity = "sha512-q583ppKrCRc7N5O0n2nzUiJ+suUv7Et1JGels4bXOaMFQcamPk9HjdUknZuuFjBNs7tsMuadge5k9RzdmO+1GQ==";
      script.crossOrigin = "anonymous";
      script.referrerPolicy = "no-referrer";
      script.async = true;
        
      document.head.appendChild(script);
      
      // Remove duplicates and update localStorage
      lazyLoadedImages = [...new Set(lazyLoadedImages)];
      localStorage.setItem("lazyLoadedImages", JSON.stringify(lazyLoadedImages));
      
    });
  